import styled from 'styled-components'

export const Container = styled.div`
  margin-top: var(--space-200);
`

export const TabsListContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: var(--border-tertiary);
`
